import { ReactElement } from 'react';

import { StyledTooltip, StyledTooltipBody } from './styles';
import { TooltipBodyProps, TooltipProps } from './types';

const Tooltip = ({
	children,
	backgroundColor = 'tooltipBg',
	textColor = 'tooltipText',
	offset = [0, 7],
	duration = [150, 100],
	absolutePositionedChild,
	textAlign,
	hasInteractiveContent,
	showArrow = true,
	disableRefWrapper = false,
	...props
}: TooltipProps): ReactElement => {
	const anchor =
		disableRefWrapper || (absolutePositionedChild && children) ? (
			children
		) : (
			<div style={{ display: 'inline-block', lineHeight: '0' }}>{children}</div>
		);
	return (
		<StyledTooltip
			$backgroundColor={backgroundColor}
			$textColor={textColor}
			$textAlign={textAlign}
			$showArrow={showArrow}
			duration={duration}
			offset={offset}
			interactive={hasInteractiveContent}
			{...props}
		>
			{anchor}
		</StyledTooltip>
	);
};

export const TooltipBody = ({
	backgroundColor = 'tooltipBg',
	textColor = 'tooltipText',
	...props
}: TooltipBodyProps): ReactElement => (
	<StyledTooltipBody
		$backgroundColor={backgroundColor}
		$textColor={textColor}
		$textAlign={props.textAlign}
		$maxWidth={props.maxWidth}
		{...props}
	/>
);

export default Tooltip;
